import {
    GETWAYLISTADMIN_SUCCESS,
    GETWAYLISTADMIN_FAILED,
    RESET_GETWAYLISTADMIN,
    LOADING_GETWAYLISTADMIN,
    NETWORK_ERROR_GETWAYLISTADMIN,
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetGetWayListAdmin = () => {
    return { type: RESET_GETWAYLISTADMIN };
};

const getWayListAdmin = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETWAYLISTADMIN });
    await adminServices
        .post("getWayList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(getWayListAdminsuccess(res.data));
                    break;
                default:
                    dispatch(getWayListAdminFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: NETWORK_ERROR_GETWAYLISTADMIN, payload: err });
        });
};
function getWayListAdminsuccess(data) {
    return {
        type: GETWAYLISTADMIN_SUCCESS,
        payload: data,
    };
}
function getWayListAdminFailed(data) {
    return {
        type: GETWAYLISTADMIN_FAILED,
        payload: data,
    };
}

export { resetGetWayListAdmin, getWayListAdmin };